import React from 'react';
import { DateOutputStr } from 'utils/DateOutput';
import * as S from './styles';

const DateSelect = ({ onChange, value, minDate, maxDate }: any) => {

  return (
    <S.DateSelect>
      <input
        alt='dateSelect'
        value={value}
        min={minDate ? minDate : undefined}
        max={maxDate ? maxDate : DateOutputStr(new Date().toISOString(), 'yyyy-MM-dd')}
        onChange={(e: any) => onChange(e.target.value)}
        type="date"
      />
    </S.DateSelect>
  );
};

export default DateSelect;
